$('.vsl-focus').on('click', function() {
    if($('#vslSection').length) {
        let videoTop = $("#vslSection").offset().top;
        
        if ($('body').hasClass('fullScreenVsl')) {
            videoTop = $("#vslSectionVsl").offset().top;
        } 

        $('html, body').animate({
            scrollTop: videoTop
        }, 1200);
    }
})